import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";


const Modeling = () => {
  const headers = ['Model'];




  useEffect(() => {


  }, [])

  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Model</h1>
        <h3>Spot the fake. Safeguard the cure.</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Model
            </div>
            {/* <Scrollspy
              offset={-140}
              className="scrollspy" items={
                headers.map(header => {
                  return header.split(' ')[0]
                })
              }
              currentClassName="active">
              {
                headers.map(header => {

                  return (
                    <li><a href={"#" + header.split(' ')[0]}>{
                      header.replace('_', '')
                    }</a></li>
                  )

                })
              }
            </Scrollspy> */}

            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Methods', 'Discussion', 'Table_1', 'Table_2', 'References']}
              currentClassName="active">
              <li><a href="#Methods">Methods</a></li>
              <li><a href="#Discussion">Discussion</a></li>
              <li><a href="#Table_1">Table 1</a></li>
              <li><a href="#Table_2">Table 2</a></li>
              <li><a href="#References">References</a></li>
           


            </Scrollspy>
            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/mascot/mascot-holding-placard-1.png"
              alt="Mascot is reading a book"
              
            />
          </div>

        </div>
        <div className="main_lab_style">
          <WindowBrowser header="Model" description={
            <>
              <div style={{ display: 'none' }}>
                {
                  headers.map(header => {
                    return (
                      <section href={header.split(' ')[0]}>{
                        header
                      }</section>
                    )

                  })
                }
              </div>
              <div>
                <section id="Methods">
                  <h1>
                    Methods
                  </h1>
                  <p>
                    The coordinates of the initial complex (7V5N, 1.70 Å) were taken from Protein Data Bank [1]. In order to predict aptamer coordinates 3dDNA web server was used for folding [2]. For virtual screening, an approach from [3] was adopted. Normalized results of 3 different models (Autodock Vina, PatchDock, and Hex), were used. Smina [4] which is a modification of Autodock vina used for docking as it is capable of setting up the simulation box automatically according to the initial ligand position. The grid box was chosen with 8 Å buffer space in each direction to ensure that different folds would fit. The exhaustiveness was 4000 and 10 best docking poses were taken for further evaluation. Hex 8.0 [5] was used with default parameters and consequent minimization using the OPLS force field. PatchDock [6] docking was performed locally with 4.0 Å RMSD clustering threshold.
                  </p>
                  <p>
                    Molecular Dynamic (MD) simulations of protein-DNA complexes were performed in GROMACS 2021.1 software [7]. The system was described by the amber14sb_ol21 force field [8]. The initial structure was solvated in a rectangular box with a 10 Å margin of TIP3P water. Na<sup>+</sup> and Cl<sup>-</sup> ions were added up to 0.15 M concentration. Non-bonded interactions were computed with a cutoff distance of 10 Å, while long-range electrostatics were addressed using the Particle-Mesh Ewald method. The SHAKE algorithm was employed to constrain all bonds involving hydrogen during the simulations. The time step used was 2 fs. The system was minimized for 8000 steps using the steepest descent algorithm to avoid steric clashes. Then it was gradually heated up from 0 to 300 K in the NVT ensemble during 1 ns and equilibrated at 1 bar and 300 K in NPT for the same time applying constraints on the protein-aptamer complex. The production run was performed for 200 ns and the last 150 ns were used for analysis.
                  </p>
                  <p>
                    The protein-aptamer binding affinity was assessed using MM/PBSA approach implemented in gmx_MMPBSA software [9] which allows using original MMPBSA.py script implemented in AmberTools in GROMACS. 50 frames were extracted from each of the trajectories for analysis time averaged values and their standard deviation were an estimate of the binding energetics.
                  </p>
                </section>

                <section id="Discussion">
                  <h1>
                    Discussion
                  </h1>

                  <p>
                    Given the project timeline and efficacy constraints, the SELEX process was deemed infeasible. Consequently, we opted to model an existing aptamer with a demonstrated high affinity for bevacizumab: 5′-GCGGTTGGTGGTAGTTACGTTCGC-3′ [10]. Utilizing the structural ideogram of the previously characterized aptamer [11], we aimed to engineer interactions involving residues that were not previously engaged in antibody binding: T5, T6, G7, G8, T9, G10, G11, T12, A13, G14, T15, T16, A17, C18, G19, T20, T21.
                  </p>

                  <p>
                    Initial attempts at molecular dynamics simulations using GROMACS proved inefficient and yielded suboptimal results when conducted randomly. Therefore, we adopted the methodology outlined by Ahirwar et al. [12]. For binding affinity predictions, we employed three distinct docking platforms: Autodock Vina, PatchDock, and Hex (Table 1).
                  </p>

                  <p>
                    <strong>Table 1. </strong> Z-score of aptamers from three different docking platforms (Autodock Vina, PatchDock, and Hex) and their cumulative sum.
                  </p>

                </section>
              </div>

              <section id="Table_1">
              <div>
                <div>
                  <section >
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: '30px' }}>
                            <p><strong>#</strong>

                            </p>
                          </td>

                          <td>
                            <p><strong> Subsequence</strong></p>
                          </td>
                          <td style={{ width: '70px' }}>
                            <p><strong>AutoDock Vina</strong></p>
                          </td>
                          <td style={{ width: '50px' }}>
                            <p><strong>PatchDock</strong></p>
                          </td>
                          <td style={{ width: '50px' }}>
                            <p><strong>Hex</strong></p>
                          </td>
                          <td style={{ width: '50px' }}>
                            <p>
                              <strong>Sum</strong>
                            </p>
                          </td>
                          <td>
                            <p><strong>Illustration</strong></p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>A14#1</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACGTTCGC-3′                            </p>
                          </td>
                          <td>
                            <p>-2.224</p>
                          </td>
                          <td>
                            <p>-1.280</p>
                          </td>
                          <td>
                            <p>-1.814</p>
                          </td>
                          <td>
                            <p>-5,318</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/bioinformatics-1.jpg"
                              alt="1" />
                          </td>
                        </tr>

                        <tr style={{backgroundColor: "#dcd3f5"}}>
                          <td>
                            <p>CU2#1</p>
                          </td>
                          <td>
                            <p>
                              5′-GCG<strong style={{ color: 'red' }}>T</strong>TTGGTGGTAGTTACGTTCGC-3′                            </p>
                          </td>
                          <td>
                            <p>-2.578</p>
                          </td>
                          <td>
                            <p>-1.350</p>
                          </td>
                          <td>
                            <p>-1.727</p>
                          </td>
                          <td>
                            <p>-5,655</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/cu2-1.png"
                              alt="3" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#2</p>
                          </td>
                          <td>
                            <p>
                              5′-GCG<strong style={{ color: 'red' }}>C</strong>TTGGTGGTAGTTACGTTCGC-3′                           </p>
                          </td>
                          <td>
                            <p>-2.055</p>
                          </td>
                          <td>
                            <p>-1.250</p>
                          </td>
                          <td>
                            <p>-1.855</p>
                          </td>
                          <td>
                            <p>-5,161
                            </p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/cu2-2.png"
                              alt="2" />
                          </td>
                        </tr>

                  

                        <tr>
                          <td>
                            <p>CU2#3</p>
                          </td>
                          <td>
                            <p>
                              5′-GCG<strong style={{ color: 'red' }}>A</strong>TTGGTGGTAGTTACGTTCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-1.678</p>
                          </td>
                          <td>
                            <p>-1.290</p>
                          </td>
                          <td>
                            <p>-1.856</p>
                          </td>
                          <td>
                            <p>-4,825</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/cu2-3.png"
                              alt="4" />
                          </td>
                        </tr>

                        <tr style={{backgroundColor: "#dcd3f5"}}>
                          <td>
                            <p>CU2#4</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGG<strong style={{ color: 'red' }}>G</strong>TGGTGGTAGTTACGTTCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-2.317</p>
                          </td>
                          <td>
                            <p>-1.260</p>
                          </td>
                          <td>
                            <p>-1.746</p>
                          </td>
                          <td>
                            <p>-5,323</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/cu2-4.png"
                              alt="5" />
                          </td>
                        </tr>

                        <tr style={{backgroundColor: "#dcd3f5"}}>
                          <td>
                            <p>CU2#5</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGG<strong style={{ color: 'red' }}>C</strong>TGGTGGTAGTTACGTTCGC-3′                         </p>
                          </td>
                          <td>
                            <p>-2.169</p>
                          </td>
                          <td>
                            <p>-1.260</p>
                          </td>
                          <td>
                            <p>-1.890</p>
                          </td>
                          <td>
                            <p>-5,319</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/cu2-5.png"
                              alt="6" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#6</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGG<strong style={{ color: 'red' }}>A</strong>TGGTGGTAGTTACGTTCGC-3′                            </p>
                          </td>
                          <td>
                            <p>-2.149</p>
                          </td>
                          <td>
                            <p>-1.270</p>
                          </td>
                          <td>
                            <p>-1.766</p>
                          </td>
                          <td>
                            <p>-5,185</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-6.png"
                              alt="7" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#7</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGT<strong style={{ color: 'red' }}>G</strong>GGTGGTAGTTACGTTCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-1.847</p>
                          </td>
                          <td>
                            <p>-1.320</p>
                          </td>
                          <td>
                            <p>-1.802</p>
                          </td>
                          <td>
                            <p>-4,969</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-7.png"
                              alt="8" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#8</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGT<strong style={{ color: 'red' }}>C</strong>GGTGGTAGTTACGTTCGC-3′                            </p>
                          </td>
                          <td>
                            <p>-1.569</p>
                          </td>
                          <td>
                            <p>-1.250</p>
                          </td>
                          <td>
                            <p>-1.771</p>
                          </td>
                          <td>
                            <p>-4,590</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-8.png"
                              alt="9" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#9</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGT<strong style={{ color: 'red' }}>A</strong>GGTGGTAGTTACGTTCGC-3′                          </p>
                          </td>
                          <td>
                            <p>-1.973</p>
                          </td>
                          <td>
                            <p>-1.230</p>
                          </td>
                          <td>
                            <p>-1.707</p>
                          </td>
                          <td>
                            <p>-4,911</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-9.png"
                              alt="10" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#10</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGG<strong style={{ color: 'red' }}>G</strong>AGTTACGTTCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-2.112</p>
                          </td>
                          <td>
                            <p>-1.350</p>
                          </td>
                          <td>
                            <p>-1.753</p>
                          </td>
                          <td>
                            <p>-5,215</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-10.png"
                              alt="11" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#11</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGG<strong style={{ color: 'red' }}>C</strong>AGTTACGTTCGC-3′                          </p>
                          </td>
                          <td>
                            <p>-1.897</p>
                          </td>
                          <td>
                            <p>-1.270</p>
                          </td>
                          <td>
                            <p>-1.744</p>
                          </td>
                          <td>
                            <p>-4,911</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-11.png"
                              alt="12" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#12</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGG<strong style={{ color: 'red' }}>A</strong>AGTTACGTTCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-2.059</p>
                          </td>
                          <td>
                            <p>-1.260</p>
                          </td>
                          <td>
                            <p>-1.749</p>
                          </td>
                          <td>
                            <p>-5,068</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-12.png"
                              alt="13" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#13</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTA<strong style={{ color: 'red' }}>G</strong>GTTCGC-3′                          </p>
                          </td>
                          <td>
                            <p>-0.889</p>
                          </td>
                          <td>
                            <p>-1.240</p>
                          </td>
                          <td>
                            <p>-1.802</p>
                          </td>
                          <td>
                            <p>-3,930</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-13.png"
                              alt="14" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#14</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTA<strong style={{ color: 'red' }}>T</strong>GTTCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-1.983</p>
                          </td>
                          <td>
                            <p>-1.300</p>
                          </td>
                          <td>
                            <p>-1.897</p>
                          </td>
                          <td>
                            <p>-5,180</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-14.png"
                              alt="15" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#15</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTA<strong style={{ color: 'red' }}>A</strong>GTTCGC-3′                           </p>
                          </td>
                          <td>
                            <p>-1.561</p>
                          </td>
                          <td>
                            <p>-1.239</p>
                          </td>
                          <td>
                            <p>-1.709</p>
                          </td>
                          <td>
                            <p>-4,510</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-15.png"
                              alt="16" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#16</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTAC<strong style={{ color: 'red' }}>C</strong>TTCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-2.043</p>
                          </td>
                          <td>
                            <p>-1.220</p>
                          </td>
                          <td>
                            <p>-1.959</p>
                          </td>
                          <td>
                            <p>-5,222</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-16.png"
                              alt="17" />
                          </td>
                        </tr>

                        <tr style={{backgroundColor: "#dcd3f5"}}>
                          <td>
                            <p>CU2#17</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTAC<strong style={{ color: 'red' }}>T</strong>TTCGC-3′                           </p>
                          </td>
                          <td>
                            <p>-2.556</p>
                          </td>
                          <td>
                            <p>-1.264</p>
                          </td>
                          <td>
                            <p>-1.725</p>
                          </td>
                          <td>
                            <p>-5,545</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-17.png"
                              alt="18" />
                          </td>
                        </tr>

                        <tr style={{backgroundColor: "#dcd3f5"}}>
                          <td>
                            <p>CU2#18</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTAC<strong style={{ color: 'red' }}>A</strong>TTCGC-3′                          </p>
                          </td>
                          <td>
                            <p>-2.674</p>
                          </td>
                          <td>
                            <p>-1.290</p>
                          </td>
                          <td>
                            <p>-1.816</p>
                          </td>
                          <td>
                            <p>-5,781</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-18.png"
                              alt="19" />
                          </td>
                        </tr>

                        <tr style={{backgroundColor: "#dcd3f5"}}>
                          <td>
                            <p>CU2#19</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACG<strong style={{ color: 'red' }}>G</strong>TCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-2.674</p>
                          </td>
                          <td>
                            <p>-1.240</p>
                          </td>
                          <td>
                            <p>-1.692</p>
                          </td>
                          <td>
                            <p>-5,607</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-19.png"
                              alt="20" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#20</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACG<strong style={{ color: 'red' }}>C</strong>TCGC-3′                           </p>
                          </td>
                          <td>
                            <p>-2.162</p>
                          </td>
                          <td>
                            <p>-1.210</p>
                          </td>
                          <td>
                            <p>-1.913</p>
                          </td>
                          <td>
                            <p>-5,5285</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-20.png"
                              alt="21" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#21</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACG<strong style={{ color: 'red' }}>A</strong>TCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-1.621</p>
                          </td>
                          <td>
                            <p>-1.270</p>
                          </td>
                          <td>
                            <p>-1.838</p>
                          </td>
                          <td>
                            <p>-4,729</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-21.png"
                              alt="22" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#22</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACGT<strong style={{ color: 'red' }}>G</strong>CGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-1.324</p>
                          </td>
                          <td>
                            <p>-1.320</p>
                          </td>
                          <td>
                            <p>-1.682</p>
                          </td>
                          <td>
                            <p>-4,326</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-22.png"
                              alt="23" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#23</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACGT<strong style={{ color: 'red' }}>C</strong>CGC-3′                           
                              </p>
                          </td>
                          <td>
                            <p>-2.102</p>
                          </td>
                          <td>
                            <p>-1.257</p>
                          </td>
                          <td>
                            <p>-1.715</p>
                          </td>
                          <td>
                            <p>-5,074</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-23.png"
                              alt="24" />
                          </td>
                        </tr>

                        <tr style={{backgroundColor: "#dcd3f5"}}>
                          <td>
                            <p>CU2#24</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACGT<strong style={{ color: 'red' }}>A</strong>CGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-2.663</p>
                          </td>
                          <td>
                            <p>-1.270</p>
                          </td>
                          <td>
                            <p>-1.655</p>
                          </td>
                          <td>
                            <p>-5,588</p>
                          </td>
                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-24.png"
                              alt="25" />
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </section>
                </div>

              </div>
              </section>

              <br>
              </br>

              <p>
                We initially considered the total binding score as a primary characteristic. Subsequently, we employed aptamers with enhanced binding affinity compared to existing ones in GROMACS to determine the time-averaged total energy (Table 2 [13, 14]. P-value was calculated based on the average MM/PBSA, standard deviation (SD), and numbers of frames). In the table below, 'NS' denotes a p-value that is not statistically significant.
              </p>
              <p>
                <strong>Table 2. </strong> GROMACS total energy results.
              </p>

              <div>
                <div>
                  <section id="Table_2">
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: '30px' }}>
                            <p><strong>#</strong>

                            </p>
                          </td>

                          <td>
                            <p><strong> Subsequence</strong></p>
                          </td>
                          <td style={{ width: '65px' }}>
                            <p><strong>MM/PBSA</strong></p>
                          </td>
                          <td style={{ width: '60px' }}>
                            <p><strong>SD</strong></p>
                          </td>
                          <td style={{ width: '60px' }}>
                            <p><strong>p-value</strong></p>
                          </td>

                          <td>
                            <p><strong>Illustration</strong></p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>A14#1</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACGTTCGC-3′                            </p>
                          </td>
                          <td>
                            <p>-142.260</p>
                          </td>
                          <td>
                            <p>-7.150</p>
                          </td>
                          <td>
                            <p>NS</p>
                          </td>

                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/bioinformatics-1.jpg"
                              alt="1" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#1</p>
                          </td>
                          <td>
                            <p>
                              5′-GCG<strong style={{ color: 'red' }}>T</strong>TTGGTGGTAGTTACGTTCGC-3′                           </p>
                          </td>
                          <td>
                            <p>-110.120</p>
                          </td>
                          <td>
                            <p>14.550</p>
                          </td>
                          <td>
                            <p>NS</p>
                          </td>

                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/cu2-1.png"
                              alt="1" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#4</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGG<strong style={{ color: 'red' }}>G</strong>TGGTGGTAGTTACGTTCGC-3′                            </p>
                          </td>
                          <td>
                            <p>-114.560</p>
                          </td>
                          <td>
                            <p>5.940</p>
                          </td>
                          <td>
                            <p>NS</p>
                          </td>

                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/cu2-4.png"
                              alt="4" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#5</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGG<strong style={{ color: 'red' }}>C</strong>TGGTGGTAGTTACGTTCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-133.710</p>
                          </td>
                          <td>
                            <p>10.800</p>
                          </td>
                          <td>
                            <p>NS</p>
                          </td>

                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/cu2-5.png"
                              alt="5" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#17</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTAC<strong style={{ color: 'red' }}>T</strong>TTCGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-132.310</p>
                          </td>
                          <td>
                            <p>12.260</p>
                          </td>
                          <td>
                            <p>NS</p>
                          </td>

                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-17.png"
                              alt="17" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#18</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTAC<strong style={{ color: 'red' }}>A</strong>TTCGC-3′                         </p>
                          </td>
                          <td>
                            <p>-124.560</p>
                          </td>
                          <td>
                            <p>46.870</p>
                          </td>
                          <td>
                            <p>NS</p>
                          </td>

                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-18.png"
                              alt="18" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#19</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACG<strong style={{ color: 'red' }}>G</strong>TCGC-3′                            </p>
                          </td>
                          <td>
                            <p>-146.170</p>
                          </td>
                          <td>
                            <p>6.750</p>
                          </td>
                          <td>
                            <p>p&lt;0.01</p>
                          </td>

                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-19.png"
                              alt="20" />
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p>CU2#24</p>
                          </td>
                          <td>
                            <p>
                              5′-GCGGTTGGTGGTAGTTACGT<strong style={{ color: 'red' }}>A</strong>CGC-3′
                            </p>
                          </td>
                          <td>
                            <p>-137.000</p>
                          </td>
                          <td>
                            <p>8.140</p>
                          </td>
                          <td>
                            <p>NS</p>
                          </td>

                          <td>
                            <img
                              src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-24.png"
                              alt="25" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </div>
              </div>
              

              <p>
                Based on the results and statistical significance (p-value), <strong>aptamer CU2#19</strong> was selected as the final candidate for device development (Picture 1). This selection was driven by its superior binding characteristics and stability, as evidenced by the docking scores and molecular dynamics simulations. The aptamer’s binding affinity was further validated through in vitro assays, confirming its potential for high specificity and sensitivity in detecting bevacizumab.
              </p>

              <br>
              </br>
              <img src="https://static.igem.wiki/teams/5334/parts/3d-images-6-24/cu2-19-2-better-quality-picture.png"></img>
              <p>
                <strong>Picture 1. </strong> Detailed interaction between aptamer<strong> CU2#19 </strong>and bevacizumab. Aptamer<strong> CU2#19 </strong>formed hydrogen bonds with T28, N31, G33, N35, N52, H101, and Y103 of bevacizumab.
              </p>

              <br></br>
              <section id="References">
                <p>
                  <h1> References </h1>
                </p>
                <ol>
                  <li>
                  Saito, T. <i>et al.</i> Development of a DNA aptamer that binds to the complementarity-determining region of therapeutic monoclonal antibody and affinity improvement induced by pH-change for sensitive detection. <i>Biosens Bioelectron</i> 203, 114027 (2022). 
                  </li>
                  <li>
                  Zhang, Y., Xiong, Y. & Xiao, Y. 3dDNA: A Computational Method of Building DNA 3D Structures. <i>Molecules </i> 27, 5936 (2022).
                  </li>
                  <li>
                  Ahirwar, R. <i>et al.</i> In silico selection of an aptamer to estrogen receptor alpha using computational docking employing estrogen response elements as aptamer-alike molecules. <i>Sci Rep</i> 6, 21285 (2016).
                  </li>
                  <li>
                  Koes, D. R., Baumgartner, M. P. & Camacho, C. J. Lessons Learned in Empirical Scoring with smina from the CSAR 2011 Benchmarking Exercise. <i>J Chem Inf Model</i> 53, 1893–1904 (2013)                  
                  </li>
                  <li>
                  Ghoorah, A. W., Devignes, M., Smaïl‐Tabbone, M. & Ritchie, D. W. Protein docking using case‐based reasoning. <i>Proteins: Structure, Function, and Bioinformatics</i> 81, 2150–2158 (2013).                  
                  </li>

                  <li>
                  Duhovny, D., Nussinov, R. & Wolfson, H. J. Efficient Unbound Docking of Rigid Molecules. in 185–200 (2002). doi:10.1007/3-540-45784-4_14.
                  </li>
                  <li>
                  Burford, A. et al. Ookami: Deployment and Initial Experiences. in <i>ACM International Conference Proceeding Series </i>(Association for Computing Machinery, 2021). doi:10.1145/3437359.3465578.
                  </li>
                  <li>
                  Zgarbová, M., Luque, F. J., Šponer, J., Otyepka, M. & Jurečka, P. A Novel Approach for Deriving Force Field Torsion Angle Parameters Accounting for Conformation-Dependent Solvation Effects. <i>J Chem Theory Comput </i>8, 3232–3242 (2012).
                  </li>
                  <li>
                  Valdés-Tresanco, M. S., Valdés-Tresanco, M. E., Valiente, P. A. & Moreno, E. gmx_MMPBSA: A New Tool to Perform End-State Free Energy Calculations with GROMACS. <i>J Chem Theory Comput</i> 17, 6281–6291 (2021).                  </li>
                  <li>
                  Yamada, T. <i>et al.</i> High-Throughput Bioanalysis of Bevacizumab in Human Plasma Based on Enzyme-Linked Aptamer Assay Using Anti-Idiotype DNA Aptamer. <i>Anal Chem</i> 91, 3125–3130 (2019).
                  </li>
                  <li>
                  Saito, T. <i>et al.</i> Development of a DNA aptamer that binds to the complementarity-determining region of therapeutic monoclonal antibody and affinity improvement induced by pH-change for sensitive detection. <i>Biosens Bioelectron</i> 203, 114027 (2022).
                  </li>
                  <li>
                  Ahirwar, R. <i>et al.</i> In silico selection of an aptamer to estrogen receptor alpha using computational docking employing estrogen response elements as aptamer-alike molecules. <i>Sci Rep</i> 6, 21285 (2016).
                  </li>
                  <li>
                  Martin, D. R. et al. Molecular modeling and simulation studies of SELEX-derived high-affinity DNA aptamers to the Ebola virus nucleoprotein. <i>J Biomol Struct Dyn</i> 1–18 (2024) doi:10.1080/07391102.2024.2302922.
                  </li>
                  <li>
                  Sabri, M. Z., Abdul Hamid, A. A., Sayed Hitam, S. M. & Abdul Rahim, Mohd. Z. <i>In Silico</i> Screening of Aptamers Configuration against Hepatitis B Surface Antigen. <i>Adv Bioinformatics</i> 2019, 1–12 (2019).
                  </li>
                </ol>
                <br></br>
                <br></br>
                <br></br>
                <br></br>


              </section>
            </>
          } />
        </div>
      </section>
    </div>
  );
}

export default Modeling;
